<template>
    <v-container max-width="100%" style="margin-top: 2%">

    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="12" md="2">
            <v-autocomplete v-model="empresaSelected" :items="empresas" item-text="razao_social" return-object clearable
              :label="$tc('company.self', 1)" @change="onEmpresaChanged"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <MultiplaEscolha
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timePropsInicio"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timePropsFim"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaRelatorio">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <MultiplaEscolha
              ref="veiculosSelect"
              lazy
              get-url="getVeiculoslazy"
              :request-data="lazySelectRequestData"
              :items="veiculosSelect"
              v-bind:selected-items.sync="idVeiculosSelected"
              text="numero_ordem"
              value="id_veiculo"
              :label="$tc('vehicle.self', 1)"
              :max-items="2"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-data-table :headers="headersVeiculosKm" :items="veiculosKm" sort-by="cod_veiculo" :sort-desc="false"
      item-key="id_veiculo" dense class="elevation-7" locale="pt" :loading="loading"
      :loading-text="$t('system.messages.loading')" :search="searchVeiculosKm" :item-class="getColorItem"
      style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;" @update:sort-by="updateSort($event)"
      @update:sort-desc="updateSortDesc($event)">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ $t('relVehicleKm.title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="searchVeiculosKm" append-icon="mdi-magnify" :label="$t('relVehicleKm.filter')"
            single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <vue-json-to-csv :json-data="veiculosKmSorted" :csv-title="'relveiculoskm'" separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>

          <ExportTablePdf :title="$t('relVehicleKm.title')" :content="veiculosKmSorted" :headers="headersVeiculosKm"
            filename="relveiculoskm"
            :subtitle="`${razaoSocial} | ${$t('relVehicleKm.refDate')} : ${dataPdfInicial} - ${dataPdfFinal}`">
          </ExportTablePdf>
        </v-toolbar>
      </template>

      <template v-slot:item.km_can="{ item }">
        <span>{{ item.km_can ? item.km_can.toFixed(2) : '' }}</span>
      </template>

      <template v-slot:item.km_virtual="{ item }">
        <span>{{ item.km_virtual ? item.km_virtual.toFixed(2) : '' }}</span>
      </template>

      <template v-slot:item.hodometro_can_inicio="{ item }">
        <span>{{ item.hodometro_can_inicio ? item.hodometro_can_inicio.toFixed(2) : '' }}</span>
      </template>

      <template v-slot:item.hodometro_can_fim="{ item }">
        <span>{{ item.hodometro_can_fim ? item.hodometro_can_fim.toFixed(2) : '' }}</span>
      </template>

      <template v-slot:item.hodometro_virtual_inicio="{ item }">
        <span>{{ item.hodometro_virtual_inicio ? item.hodometro_virtual_inicio.toFixed(2) : '' }}</span>
      </template>

      <template v-slot:item.hodometro_virtual_fim="{ item }">
        <span>{{ item.hodometro_virtual_fim ? item.hodometro_virtual_fim.toFixed(2) : '' }}</span>
      </template>

    </v-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import DateUtils from "../utils/dateutils";
import VueJsonToCsv from "vue-json-to-csv";
import ExportTablePdf from "./ExportTablePdf.vue";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

export default {
  components: {
    VueJsonToCsv,
    ExportTablePdf,
    MultiplaEscolha,
  },
  data: () => ({
    autorizacaoDialog: false,
    mensagemAutorizacaoDialog: "",
    user: null,
    token: null,
    config: null,
    loading: false,
    searchVeiculosKm: "",
    recursos: [],
    empresas: [],
    dti: null,
    dtf: null,
    empresaSelected: null,
    veiculos: [],
    veiculosSelect: [],
    idVeiculosSelected: [],
    unidadesSelecionadas: [],
    veiculosKm: [],
    veiculosKmRaw: [],
    formValidado: false,
    sortBy: null,
    sortDesc: false,
    setup: {
      has_validador: 0,
      has_queclink: 0,
      has_detro: 0,
    },
  }),
  watch: {
    '$i18n.locale'() {
      this.initialize();
    },
    unidadesSelecionadas() {
      this.populaVeiculosSelect();
      this.atualizarVeiculosKmFiltrados();
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.getConfig();
    this.initialize();
  },
  computed: {
    headersVeiculosKm() {
      let headers = [
        { "text": this.$t('relVehicleKm.headersVeiculosKm.code'), "value": "cod_veiculo" },
      ];

      if (this.setup.has_validador == 1) {
        headers.push({ "text": this.$t('relStatusVehicle.headers.codePordataIntegretion'), "value": "cod_integracao" });
      }

      if (this.setup.has_queclink == 1) {
        headers.push({ "text": this.$t('relVehicleKm.headersVeiculosKm.equipment'), "value": "cod_integracao_queclink" });
      }

      headers.push(...[
        { "text": this.$t('relVehicleKm.headersVeiculosKm.canOdometerStart'), "value": "hodometro_can_inicio" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.canDateStart'), "value": "dt_coleta_can_inicio" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.canOdometerEnd'), "value": "hodometro_can_fim" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.canDateEnd'), "value": "dt_coleta_can_fim" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.canKm'), "value": "km_can" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.virtualOdometerStart'), "value": "hodometro_virtual_inicio" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.virtualDateStart'), "value": "dt_coleta_virtual_inicio" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.virtualOdometerEnd'), "value": "hodometro_virtual_fim" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.virtualDateEnd'), "value": "dt_coleta_virtual_fim" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.virtualKm'), "value": "km_virtual" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.tripKm'), "value": "km_viagem" },
        { "text": this.$t('relVehicleKm.headersVeiculosKm.idleKm'), "value": "km_ociosa" }
      ]);

      return headers;
    },
    razaoSocial() {
      return this.empresaSelected ? this.empresaSelected.razao_social : this.$t('company.allTheCompanies');
    },
    dataPdfInicial() {
      return this.dti ? this.dti.toLocaleString() : null;
    },
    dataPdfFinal() {
      return this.dtf ? this.dtf.toLocaleString() : null;
    },
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    yesterday() {
      let d = new Date();
      d.setDate(d.getDate() - 1)
      return d.toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.yesterday
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min,
        max: this.today
      }
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [this.dateTimeRules],
      };
    },
    timePropsInicio() {
      return {
        useSeconds: false,
        allowedMinutes: ["00"],
        allowedHours: this.allowedHoursInicio,
      }
    },
    timePropsFim() {
      return {
        useSeconds: false,
        allowedMinutes: ["00"],
        allowedHours: this.allowedHoursFim,
      }
    },
    semUnidadeOption() {
      return [
        {
          id_unidade: -1,
          descricao_unidade: 'Sem Unidade',
          cod_unidade: 'SU',
        },
      ];
    },
    lazySelectRequestData() {
      const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
      const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
      const temSemUnidade = unidades.includes(-1);
      if (reais.length === 1 && !temSemUnidade) {
        return { id_unidade: reais[0] };
      }
      if (temSemUnidade && reais.length === 0) {
        return { id_unidade: -1 };
      }
      return {};
    },
    veiculosKmSorted() {
      if (!this.sortBy) {
        return this.veiculosKm;
      }

      if ([
        "km_can",
        "km_virtual",
        "hodometro_can_inicio",
        "hodometro_can_fim",
        "hodometro_virtual_inicio",
        "hodometro_virtual_fim"
      ].includes(this.sortBy)) {
        return [...this.veiculosKm.filter((e) => !isNaN(parseFloat(e[this.sortBy]))).sort((a, b) => {
          let result = 0;

          if (parseFloat(a[this.sortBy]) > parseFloat(b[this.sortBy])) {
            result = 1;
          } else if (parseFloat(a[this.sortBy]) == parseFloat(b[this.sortBy])) {
            result = 0;
          } else {
            result = -1;
          }
          return this.sortDesc ? -1 * result : result;
        }), ...this.veiculosKm.filter((e) => isNaN(parseFloat(e[this.sortBy])))];
      }

      return [...this.veiculosKm].sort((a, b) => {
        let result = 0;

        if (!a[this.sortBy]) {
          result = -1;
        } else if (!b[this.sortBy]) {
          result = 1;
        } else if (a[this.sortBy] > b[this.sortBy]) {
          result = 1;
        } else if (a[this.sortBy] == b[this.sortBy]) {
          result = 0;
        } else {
          result = -1;
        }

        return this.sortDesc ? -1 * result : result;
      });
    },
  },
  methods: {
    filtraItensLazyParaIds(dados) {
      if (!dados || !Array.isArray(dados)) {
        return [];
      }
      let filtrados = dados;
      if (this.empresaSelected) {
        filtrados = filtrados.filter((d) => d.id_empresa == this.empresaSelected.id_empresa);
      } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
        filtrados = filtrados.filter((d) => d.id_cliente == this.user.id_cliente);
      }
      if (this.unidadesSelecionadas && this.unidadesSelecionadas.length > 0) {
        const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
        filtrados = filtrados.filter((d) => {
          if (Array.isArray(d.unidades) && d.unidades.length > 0) {
            return d.unidades.map((id) => Number(id)).some((u) => selecionadas.includes(u));
          }
          if (d.id_unidade != null && d.id_unidade !== '') {
            return selecionadas.includes(Number(d.id_unidade));
          }
          if (d.id_linha != null && d.id_veiculo == null && d.id_funcionario == null) {
            return true;
          }
          return selecionadas.includes(-1);
        });
      }
      return filtrados;
    },
    async resolveLazySelectIds(refName, selectedIds, valueKey) {
      if (Array.isArray(selectedIds) && selectedIds.length > 0) {
        return { ids: selectedIds, implicit: false };
      }
      const selectRef = this.$refs[refName];
      if (!selectRef || typeof selectRef.fetchAllLazyItems !== 'function') {
        return { ids: [], implicit: true };
      }
      const { items } = await selectRef.fetchAllLazyItems({
        search: '',
        requestDataOverride: this.lazySelectRequestData,
      });
      const ids = this.filtraItensLazyParaIds(items || [])
        .map((item) => item[valueKey])
        .filter((id) => id != null && id !== '');
      return { ids, implicit: true };
    },
    idsUnidadesNoObjeto(o) {
      if (Array.isArray(o.unidades) && o.unidades.length) {
        return o.unidades.map((id) => Number(id));
      }
      if (o.id_unidade != null && o.id_unidade !== "") {
        return [Number(o.id_unidade)];
      }
      return [];
    },
    passaFiltroUnidades(o) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
      return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
    },
    atualizarVeiculosKmFiltrados() {
      this.veiculosKm = (this.veiculosKmRaw || []).filter((v) => this.passaFiltroUnidades(v));
    },
    initialize() {
      this.populaRecursos();
      this.populaSetup();
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
        },
      });
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        onSuccess: (response) => {
          this.setup = response.data[0];
        },
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.populaEmpresas();
            this.populaVeiculos();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.populaEmpresas();
            this.populaVeiculos();
          },
        });
      }
    },
    populaEmpresas() {
      this.empresas = this.recursos.map((r) => { if (r.id_empresa) return {id_empresa: r.id_empresa, razao_social: r.razao_social} });
    },
    onEmpresaChanged() {
      this.idVeiculosSelected = [];
      this.populaVeiculosSelect();
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculos, {
        onSuccess: (response) => {
          this.veiculos = (response.data || []).filter((e) => this.recursos.findIndex((r) => r.id_empresa === e.id_empresa) !== -1);
          this.populaVeiculosSelect();
        },
      });
    },
    populaVeiculosSelect() {
      let veiculosFiltrados = this.veiculos;
      if (this.empresaSelected) {
        veiculosFiltrados = veiculosFiltrados.filter((v) => v.id_empresa == this.empresaSelected.id_empresa);
      }
      veiculosFiltrados = veiculosFiltrados.filter((v) => this.passaFiltroUnidades(v));
      this.veiculosSelect = veiculosFiltrados.map((v) => ({
        ...v,
        numero_ordem: v.numero_ordem || v.cod_veiculo || v.placa || String(v.id_veiculo),
      }));
    },
    populaVeiculosKm(body) {
      apiController.request(apiController.endpoints.getVeiculosrelatoriokm, {
        data: body,
        onSuccess: (response) => {
          this.veiculosKmRaw = response.data || [];
          this.atualizarVeiculosKmFiltrados();
          if (!this.sortBy) {
            this.sortBy = "km_can";
            this.sortDesc = true;
          }
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    async populaRelatorio() {
      this.formValidado = this.$refs.form.validate();
      if (!this.formValidado) {
        return;
      }

      this.loading = true;
      this.veiculosKmRaw = [];
      this.veiculosKm = [];

      try {
        const veiculosRes = await this.resolveLazySelectIds(
          'veiculosSelect',
          this.idVeiculosSelected,
          'id_veiculo'
        );

        if (veiculosRes.implicit && veiculosRes.ids.length === 0) {
          this.loading = false;
          return;
        }

        const dataInicial = DateUtils.getDateSQLFormatted(this.dti);
        const dataFinal = DateUtils.getDateSQLFormatted(this.dtf);
        const param = this.$tc('vehicle.self', 1);

        const body = {
          ids: veiculosRes.ids,
          dti: dataInicial,
          dtf: dataFinal,
          param,
        };

        this.populaVeiculosKm(body);
      } catch (_err) {
        this.loading = false;
      }
    },
    updateSort(event) {
      this.sortBy = event;
    },
    updateSortDesc(event) {
      this.sortDesc = event;
    },
    dateTimeRules(v) {
      if (!v) {
        return this.$t('contract.messages.selectDate')
      }

      if (this.dtf <= this.dti) {
        return this.$t('datetime.startDateAfterEndDate')
      }

      return true;
    },
    allowedHoursInicio(v) {
      if (this.dti && this.dtf) {
        if (this.dti.toISOString().substring(0, 10) == this.dtf.toISOString().substring(0, 10)) {
          return v < this.dtf.getHours();
        }
      }

      return true;
    },
    allowedHoursFim(v) {
      if (this.dti && this.dtf) {
        if (this.dti.toISOString().substring(0, 10) == this.dtf.toISOString().substring(0, 10)) {
          return v > this.dti.getHours();
        }
      }

      return true;
    },
    getColorItem(item) {
      if (!item.km_can && !item.km_virtual) {
        return "item__sem__dados";
      }

      if (item.km_can > 0 || item.km_virtual > 0) {
        return "item__com__dados";
      }

      return "item__sem__dados";
    }
  }
}
</script>
<style>
.item__com__dados {
  color: #2E7D32;
  font-weight: bold;
}

.item__sem__dados {
  color: #4a4a4a;
}
</style>
